import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay  } from 'swiper/modules';

export function initSliders() {

// Testimonial slider
const testimonialSwiper = new Swiper('.swiper-testimonials', {
	modules: [Navigation],
	navigation: {
		nextEl: '.swiper-testimonials .swiper-button-next',
		prevEl: '.swiper-testimonials .swiper-button-prev',
	},
	loop: true,
});

// Product slider
const productSwiper = new Swiper('.swiper-product', {
	modules: [Navigation, Pagination],
	navigation: {
		nextEl: '.product-slider.swiper-button-next',
		prevEl: '.product-slider.swiper-button-prev',
	},
  pagination: {
		el: '.product-slider.swiper-pagination',
		clickable: true,
	},
	loop: true,
});

// Frontpage Hero slider
const heroSwiper = new Swiper('.swiper-hero', {
  modules: [Autoplay],
	autoplay: {
		delay: 4500,
		disableOnInteraction: false,
	},
	loop: true,
});

// Testimonial slider
const caseSwiper = new Swiper('.swiper-case', {
	modules: [Navigation],
  autoHeight: false,
	navigation: {
		nextEl: '.swiper-case .swiper-button-next',
		prevEl: '.swiper-case .swiper-button-prev',
	},
	loop: true,
});

}